"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialTags = void 0;
exports.SpecialTags = {
    NONE: 'none',
    INFLUENCE: 'influence-count',
    CITY_COUNT: 'city-count',
    COLONY_COUNT: 'colony-count',
    UNDERGROUND_TOKEN_COUNT: 'underground-token-count',
    CORRUPTION: 'corruption-count',
    NEGATIVE_VP: 'negative-vp',
};
